/**
 * Routini API — Management
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TaxiTripAddPossibilityReason = {
    Fits: 'Fits',
    NoTimeAndLocationFit: 'NoTimeAndLocationFit',
    NoAvailableSpaceFit: 'NoAvailableSpaceFit',
    NoVehicleInTour: 'NoVehicleInTour',
    TourAlreadyStarted: 'TourAlreadyStarted',
    WouldCreateVehicleOverlap: 'WouldCreateVehicleOverlap',
    NoFitInPinnedOrder: 'NoFitInPinnedOrder'
} as const;
export type TaxiTripAddPossibilityReason = typeof TaxiTripAddPossibilityReason[keyof typeof TaxiTripAddPossibilityReason];

